import axios from '@/libs/axios';
import { queryClient } from '@/libs/react-query';
import { useMutation } from '@tanstack/react-query';
import { ListQueryKey, Urls } from '../constant'; //

//
export const deletion = data => {
  return axios.post(Urls.deleteUrl, { ...data,
    commodity_id: data.id
  });
};
//
export const useDelete = ({
  config
}) => {
  return useMutation({
    onSettled: () => {
      queryClient.invalidateQueries([ListQueryKey]);
    },
    mutationFn: deletion,
    ...config
  });
};